import { render, staticRenderFns } from "./oilProductList.vue?vue&type=template&id=76bccc37&scoped=true"
import script from "./oilProductList.vue?vue&type=script&lang=js"
export * from "./oilProductList.vue?vue&type=script&lang=js"
import style0 from "./oilProductList.vue?vue&type=style&index=0&id=76bccc37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bccc37",
  null
  
)

export default component.exports